import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useOpenEditSegmentsModal } from '../../../utils/routes/modals/modalsActions'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import { COLORS } from '@btime/constants'
import { useIsOwner } from '@btime/react-session'

const EditSegmentationPage = ({ id }) => {
  const navigate = useNavigation()
  const { t } = useTranslation('editSegmentation')
  const openBulkModal = useOpenEditSegmentsModal()
  const isOwner = useIsOwner()

  const context = id > 0 && 'edit'
  const title = t('title', { context })

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate('/segmentations')}
      title={title}
      mediumPadding
      noContainer
      side={
        isOwner && (
          <Link
            onClick={() => openBulkModal({ ids: [] })}
            block
            loading={false}
            loadingColor={COLORS.white}
            loadingBgColor={COLORS.purple}
          >
            <IconText iconSize="1.4rem" weight="700" color={COLORS.white} label={t('bulkEdit')} noWrap />
          </Link>
        )
      }
    />
  )
}

export default EditSegmentationPage
